(function () {
    if (window.location.pathname === '/cart' || window.location.pathname.startsWith('/cart/')) {
        return;
    }
  const REQUIRED_TAG = 'finalsale';
  const MESSAGE_TEXT = 'This item is final sale';
  const MESSAGE_CLASS = 'js-final-sale-message';
  const PRODUCT_CACHE_KEY = 'product_tags_cache_v1';
  const CACHE_TTL_MS = 5 * 60 * 1000;

  function createMessageElement(text) {
    const p = document.createElement('p');
    p.className = MESSAGE_CLASS;
    p.textContent = text;
    p.style.marginTop = '0px';
    p.style.fontSize = '0.694375rem';
    p.style.color = '#f64747';
    return p;
  }

  function readCache() {
    try {
      const raw = sessionStorage.getItem(PRODUCT_CACHE_KEY);
      if (!raw) return {};
      const parsed = JSON.parse(raw);
      const now = Date.now();
      Object.keys(parsed).forEach(k => {
        if (!parsed[k].ts || now - parsed[k].ts > CACHE_TTL_MS) delete parsed[k];
      });
      return parsed;
    } catch {
      return {};
    }
  }

  function writeCache(cache) {
    try {
      sessionStorage.setItem(PRODUCT_CACHE_KEY, JSON.stringify(cache));
    } catch {}
  }

  async function fetchProductTags(handle) {
    const cache = readCache();
    if (cache[handle]?.tags) return cache[handle].tags;
    try {
      const res = await fetch(`/products/${encodeURIComponent(handle)}.js`);
      if (!res.ok) throw new Error('no product');
      const json = await res.json();
      const tags = Array.isArray(json.tags)
        ? json.tags
        : typeof json.tags === 'string'
        ? json.tags.split(',').map(t => t.trim())
        : [];
      cache[handle] = { tags, ts: Date.now() };
      writeCache(cache);
      return tags;
    } catch {
      cache[handle] = { tags: [], ts: Date.now() };
      writeCache(cache);
      return [];
    }
  }

  async function processCartAndRender() {
    try {
      const cartRes = await fetch('/cart.js');
      if (!cartRes.ok) return;
      const cart = await cartRes.json();
      if (!Array.isArray(cart.items)) return;

      await Promise.all(
        cart.items.map(async (item, idx) => {
          const lineEl = document.querySelector(`.line-item[index="${idx}"]`);
          if (!lineEl) return;
          const bodyEl = lineEl.querySelector('.line-item__body') || lineEl;
          if (!bodyEl) return;

          const prev = bodyEl.querySelector('.' + MESSAGE_CLASS);
          if (prev) prev.remove();

          const handle = item.handle || (item.url?.match(/\/products\/([^/?#]+)/) || [])[1];
          if (!handle) return;

          const tags = await fetchProductTags(handle);
          const has = tags.some(t => t.toLowerCase() === REQUIRED_TAG.toLowerCase());
          if (has) {
            const header = bodyEl.querySelector('.line-item__header');
            const msg = createMessageElement(MESSAGE_TEXT);
            header?.insertAdjacentElement('afterend', msg);
          }
        })
      );
    } catch (err) {
      console.error('processCartAndRender error', err);
    }
  }

  function setupObservers() {
    const targets = [
      document.querySelector('.cart-drawer__products'),
      document.querySelector('.main-cart__line-items'),
      document.querySelector('.cart-drawer__body'),
      document.querySelector('.cart-drawer')
    ].filter(Boolean);

    targets.forEach(container => {
      if (container.__finalSaleObserverAttached) return;
      const mo = new MutationObserver(() => {
        clearTimeout(window.__finalSaleTimer);
        window.__finalSaleTimer = setTimeout(processCartAndRender, 200);
      });
      mo.observe(container, { childList: true, subtree: true });
      container.__finalSaleObserverAttached = true;
    });
  }

  // --- Event Hooks ---
  document.addEventListener('DOMContentLoaded', () => {
    processCartAndRender();
    setupObservers();
  });

  window.addEventListener('pageshow', processCartAndRender);
  window.addEventListener('popstate', () => setTimeout(processCartAndRender, 250));
  window.addEventListener('focus', () => setTimeout(processCartAndRender, 150));

  ['cart:updated', 'cart:update', 'cart:refresh', 'ajaxCart.afterRender', 'cart:refresh:after'].forEach(ev =>
    window.addEventListener(ev, () => {
      clearTimeout(window.__finalSaleTimer);
      window.__finalSaleTimer = setTimeout(processCartAndRender, 150);
    })
  );
})();
